import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('SCHEMA_ERRORS.NAME_REQUIRED'),
  city: Yup.string().required('SCHEMA_ERRORS.SELECT_VALUE')
});
